import { configureStore } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import rootReducer from "../reducers";
import { RootState } from '../types';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;

export type AppDispatch = typeof store.dispatch;


  
